var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableSpots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9778 1.59961H3.0222C2.23998 1.59961 1.59998 2.23961 1.59998 3.02183V12.9774C1.59998 13.7596 2.23998 14.3996 3.0222 14.3996H12.9778C13.76 14.3996 14.4 13.7596 14.4 12.9774V3.02183C14.4 2.23961 13.76 1.59961 12.9778 1.59961ZM5.86664 11.5552H4.44442V6.57739H5.86664V11.5552ZM8.71109 11.5552H7.28886V4.44405H8.71109V11.5552ZM11.5555 11.5552H10.1333V8.71072H11.5555V11.5552Z",
    fill: "#C0C0CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableSpots);
export default __webpack_public_path__ + "static/media/available-spots.e3e310710d29e719883e2b9e29e5644c.svg";
export { ForwardRef as ReactComponent };